<template>
  <div style="height: 100%;">
    <view-box
      :body-padding-top="$route.meta.header === false || isZlb ? 0 : '46px'"
      :body-padding-bottom="bottom"
    >
      <x-header
        v-if="$route.meta.header !== false && !isZlb"
        slot="header"
        :left-options="{ showBack: showBack }"
        :right-options="{ showMore: $store.state.user.name }"
        @on-click-more="showMenus = true"
        @on-click-title="handleChangeRank"
        :title="title"
        style="width:100%;position:absolute;left:0;top:0;z-index:100;"
      ></x-header>
      <router-view></router-view>
      <tabbar
        slot="bottom"
        class="tabbar"
        v-if="$route.meta && $route.meta.tab"
      >
        <tabbar-item
          :selected="$route.meta.tab === 'index'"
          :link="{ path: '/', replace: true }"
        >
          <Icon slot="icon" style="font-size: 24px;" :type="tab.index.icon" />>
          <span slot="label">首页</span>
        </tabbar-item>
        <tabbar-item
          :selected="tab.order.active"
          :link="{ path: '/order', replace: true }"
        >
          <Icon slot="icon" style="font-size: 24px;" :type="tab.order.icon" />
          <span slot="label">订单</span>
        </tabbar-item>
        <tabbar-item
          :selected="tab.profile.active"
          :link="{ path: '/profile', replace: true }"
        >
          <Icon slot="icon" style="font-size: 24px;" :type="tab.profile.icon" />
          <span slot="label">我的</span>
        </tabbar-item>
      </tabbar>
    </view-box>
    <div v-transfer-dom>
      <actionsheet
        :menus="menus"
        v-model="showMenus"
        show-cancel
        @on-click-menu="onClickMenu"
      ></actionsheet>
      <actionsheet
        :menus="roleMenus"
        v-model="showRoleMenus"
        show-cancel
        @on-click-menu="onClickRoleMenu"
      ></actionsheet>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { Tabbar, TabbarItem, ViewBox, XHeader } from "vux";
import { getZlb } from "../utils/auth";

export default {
  components: {
    Tabbar,
    TabbarItem,
    ViewBox,
    XHeader
  },
  data() {
    return {
      isZlb: false,
      showMenus: false,
      showRoleMenus: false,
      menus: {
        home: "回到首页",
        logout: "退出",
        choiceRole: "更换角色"
      }
    };
  },
  created() {
    if (getZlb() === "zlb") {
      this.isZlb = true;
    } else {
      this.isZlb = false;
    }
  },
  computed: {
    ...mapGetters(["roleMenus", "role"]),
    bottom() {
      if (this.$route.meta.tab) {
        return "53px";
      }
      if (!this.$route.meta.tab) {
        return "0px";
      }
      return "";
    },
    showBack() {
      if (this.$route.meta) {
        return this.$route.meta.showBack !== false;
      } else {
        return true;
      }
    },

    title() {
      if (this.$route.meta && this.$route.meta.title) {
        return this.$route.meta.title;
      }
      return "";
    },
    tab() {
      const tab = this.$route.meta.tab;
      return {
        index: {
          active: tab === "index",
          icon: tab === "index" ? "iconicon-test" : "iconkaobei"
        },
        order: {
          active: tab === "order",
          icon: tab === "order" ? "iconxingzhuangkaobei1" : "iconxingzhuang"
        },
        profile: {
          active: tab === "profile",
          icon: tab === "profile" ? "iconxingzhuangkaobei" : "iconxingzhuang1"
        }
      };
    }
  },
  methods: {
    ...mapActions(["logout", "changeRole"]),
    ...mapMutations(["CLEAR_ROLE"]),
    handleChangeRank() {
      if (this.$route.path === "/user/teamRank") {
        this.$router.replace("/user/personRank");
      } else if (this.$route.path === "/user/personRank") {
        this.$router.replace("/user/teamRank");
      }
    },
    handleLogout() {
      this.logout();
      this.CLEAR_ROLE();
      this.$navigation.cleanRoutes();
      this.$router.push({ name: "Login" });
    },

    onClickMenu(key) {
      switch (key) {
        case "home":
          this.$navigation.cleanRoutes();
          this.$router.replace("/");
          break;
        case "logout":
          this.handleLogout();
          break;
        case "choiceRole":
          this.showRoleMenus = true;
          this.showMenus = false;
          break;
      }
    },

    onClickRoleMenu(roleId) {
      this.changeRole(+roleId);
    }
  }
};
</script>
<style lang="less" scoped>
.tabbar {
  background: #ffffff;
}
.icon-wrapper {
  position: absolute;
  width: 86px - 16px * 2;
  height: 86px - 16px * 2;
  padding: 16px;
  background: rgba(246, 246, 246, 1);
  border: 1px solid rgba(241, 241, 241, 1);
  border-radius: 50%;
  top: -40px;
  left: -10px;
  img {
    height: 100%;
  }
}
</style>
